import JSONstringifyWithoutNulls from "./JSONstringifyWithoutNulls";
export default class Filter extends JSONstringifyWithoutNulls {
    constructor() {
        super(...arguments);
        this.Search = null;
        this.PayGrade = null;
        this.Rank = null;
        this.Component = null;
        this.YearOfBirth = null;
        this.YearOfDeath = null;
        this.YearOfEntry = null;
        this.YearOfDischarge = null;
    }
}
